import React, { useEffect } from 'react';
import { connect } from 'react-redux';

// import Grid from '@mui/material/Grid';
// import HospitalIcon from '@mui/icons-material/LocalHospitalOutlined';

import { HospitalsTableContainer } from '../../components/hospitals';
// import StatsBox from '../../components/shared/StatsBox';

import { fetchHospitals } from '../../actions/adminActions';

import './admin.scss';

const HospitalsPage = ({ fetchHospitals, hospitals, countries, companies }) => {
  useEffect(() => {
    fetchHospitals();
  }, [fetchHospitals])

  return (
    <div className="admin-page">
      {/*<Grid container spacing={3} sx={{ mb: 3 }}>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Hospitals' number={hospitals?.length} icon={<HospitalIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Hospitals' number={hospitals?.length} icon={<HospitalIcon />} />*/}
      {/*  </Grid>*/}
      {/*  <Grid size={{ xs: 12, md: 4 }}>*/}
      {/*    <StatsBox title='Total Hospitals' number={hospitals?.length} icon={<HospitalIcon />} />*/}
      {/*  </Grid>*/}
      {/*</Grid>*/}
      <HospitalsTableContainer
        hospitals={hospitals}
        countries={countries}
        companies={companies}
        withButton
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  hospitals: state.hospitals.list,
  countries: state.countries.list,
  companies: state.companies.list,
});

const mapDispatchToProps = (dispatch) => ({
  fetchHospitals: () => dispatch(fetchHospitals()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(HospitalsPage);
